



































import { computed, defineComponent, ref } from '@vue/composition-api'
import store from '@/store'
import { TechnicalSkillActions } from '@/store/modules/technical-skills/actions'
import { TechnicalSkillGetters } from '@/store/modules/technical-skills/getters'
import { TechnicalSkillInterface } from '@/store/modules/technical-skills/types'

export default defineComponent({
  name: 'TechSkills',
  setup() {
    const isTechStackDisplayed = ref<boolean>(false)

    const skills = computed<Array<TechnicalSkillInterface>>(() => store.getters[TechnicalSkillGetters.All])

    store.dispatch(TechnicalSkillActions.SetTechnicalSkills)

    function flipTechStackDisplay(){
      isTechStackDisplayed.value = !isTechStackDisplayed.value
    }

    return {
      isTechStackDisplayed,
      flipTechStackDisplay,
      skills
    }
  },
})
